const BusinessBadgeGroup = ({ items }) => {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {items.map((item, index) => (
        <div
          key={index}
          className="bg-[#F1F5FF] flex flex-row items-center gap-2 rounded-lg py-1 px-2.5 border border-primary-blur-015 text-[#253477]"
        >
          <span className="lg:text-[10px] text-[8px]">{item}</span>
        </div>
      ))}
    </div>
  );
};

export default BusinessBadgeGroup;
